module.exports = __webpack_public_path__ + "static/media/barrierefreiheit.40f9af57.png";